import { DEBUG } from '@glimmer/env';
import { SafeString } from 'handlebars/dist/handlebars';

/**
 * Link component allows Drupal content to link to URLS external to RISE UI.
 */
export function link(...args) {
  const options = args.pop();
  const attrs = [ 'id', 'class' ]
    .map(a => options.hash[a] ? ` ${a}="${options.hash[a]}"` : '')
    .join('');
  if (DEBUG) {
    if (!args.length) {
      console.error(`Missing \`link\` helper url argument.`);
    }
  }
  return new SafeString(`<a href="${args[0]}"${attrs} rel="noopener noreferrer" target="_blank">`
    + `${options.fn(this)}\n<span class="c-external-link__icon">`
    + '<span class="c-icon c-icon--external-link" title="Opens in new window"></span>'
    + '<span class="c-icon__text">Opens in new window</span></span></a>'
  );
}
